'use strict'

var App = require('app')

var EditNewController = require('src/components/edit_new-controller.js')
var View = require('./view.js')
var DialogModel = require('src/common/dialog-model.js')

var Moment = require('moment')

var ClientNew = function (options) {
  /**
   * Extend the EditNewController which has some specialized functions
   */
  var Controller = EditNewController.extend({
    initialize: function (options) {
      this.region = options.region

      var clients = options.collection
      var client = options.model

      if (!client) client = App.globalChannel.request('client:entity:new')

      // define the dialog model
      var dialogModel = new DialogModel({
        title: 'client',
        buttons: {
          left: [
            { label: 'delete', icon: true, slug: 'delete', action: 'dialog:delete', roles: ['super'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        },
        tabs: [
          { label: 'Basic', slug: 'basic', elementId: 'tab-basic', roles: [] },
          { label: 'Settings', slug: 'settings', elementId: 'tab-settings', roles: [] },
          { label: 'Vendors', slug: 'vendors', elementId: 'tab-vendors', roles: ['super'] }
        ]
      })

      // load view
      this.view = this.getLayoutView(dialogModel, client, clients)

      // listen
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)

      App.rootLayout.showChildView('dialogRegion', this.view)
    },

    /**
     * Before sending the data to the server
     * 1. Handle operatingtimes setting
     */
    formPreSave: function (model, data) {
      var operatingTimes = {}
      // convert visual field
      if (data.settings.operatingTimes) {
        if (data.settings.operatingTimes.startTime !== '00:00' && data.settings.operatingTimes.endTime !== '00:00') {
          var startTime = Moment('1970-01-01 ' + data.settings.operatingTimes.startTime)
          var endTime = Moment('1970-01-01 ' + data.settings.operatingTimes.endTime)

          operatingTimes = {
            startTime: startTime.format(),
            endTime: endTime.format()
          }
        }

        data.settings.operatingTimes = operatingTimes
      }

      // if parentClient is not set, make it empty
      if (data.parentClient == '') data.parentClient = null;

      return data
    },
    /* Event methods --------------------------------------------------------- */
    onDeleteMessage: function (model, message) {
      return 'Are you sure you want to delete the client "' + model.get('name') + '" and all its users?'
    },
    /* Views ----------------------------------------------------------------- */
    getLayoutView: function (dialogModel, client, clients) {
      return new View.Layout({
        model: client,
        collection: clients,
        dialogModel: dialogModel
      })
    }

  })

  return new Controller(options)
}

module.exports = ClientNew



// WEBPACK FOOTER //
// ./js/modules/page-clients/edit_new/index.js